const sourceOfFundingData = [
  "HRZZ",
  "Horizon Europe",
  "Europski socijalni fond",
  "Europski fond za regionalni razvoj",
  "Drugi strukturni fondovi",
  "Erasmus +",
  "INTERREG",
  "Jedinica lokalne samouprave",
  "NPOO",
  "COST",
  "MSCA",
];

const projectTypesData = [
  "Međunarodni znanstveni kompetitivni",
  "Nacionalni znanstveni kompetitivni",
  "Stručni projekt",
  "Strateški projekt",
  "Infrastrukturni projekt",
  "Suradnja s gospodarstvom",
  "Podizanje kapaciteta",
  "Donacija",
];

export { projectTypesData, sourceOfFundingData };
